import * as types from '../actions/types'
import createReducer from '../createReducer'
import { updateState } from '../handlers'
import { colsShowInit } from 'constants/conversationSearch'

const initialCvSearchState = {
  lastSearchedUsers: '',
  isSearchingUsers: false,
  searchUsersSuccess: false,
  searchUsersFailure: false,
  searchUsersError: '',

  lastUpdatedUsersQuery: '',
  isFetchingQueryUsers: false,
  fetchUsersQuerySuccess: false,
  fetchUsersQueryFailure: false,
  fetchUsersQueryError: '',

  cols_order: colsShowInit,

  brands: [],
  delegations: [],
  search_users: [],
  checked: [],
  isAllChecked: false,
  search_users_count: 0,
  total_users_query: 0,
  filters: {
    limit: 30,
    sortField: 'pendingMsgCount',
    sortType: 'desc',
    page: 0,
    searchText: '',
    outbound: false,
    assigned: [],
    providers: [],
    brands: [],
    delegations: [],
    states: [],
    labels: [],
    folders: [],
    createdAt: ['', ''],
    updatedAt: ['', ''],
    lastMessageDate: ['', '']
  },
  users_query: [],
  searcher: {
    flight: {
      isOpen: false,
    },
    hotel: {
      isOpen: false,
    },
  }
}

export default createReducer(initialCvSearchState, {
  // RESET FILTERS
  [types.RESET_USER_SEARCH_FILTERS](state, action) {
    const newState = Object.assign({}, state, {
      filters: {
        ...state.filters,
        limit: 30,
        searchText: '',
        outbound: false,
        assigned: [],
        providers: [],
        brands: [],
        delegations: [],
        states: [],
        labels: [],
        folders: [],
        createdAt: ['', ''],
        updatedAt: ['', ''],
        lastMessageDate: ['', '']
      }
    })

    return newState
  },
  // UPDATE FILTERS
  [types.UPDATE_USERS_SEARCH_FILTERS](state, action) {
    return Object.assign({}, state, {
      filters: action.field === 'brandsAndDelegations' ? {
        ...state.filters,
        brands: action.value.brands,
        delegations: action.value.delegations
      } : {
        ...state.filters,
        [action.field]: action.value
      }
    })
  },
  [types.UPDATE_USERS_SEARCH_ORDER](state, action) {
    const { sortField } = action.payload
    const currentFilters = state.filters

    let sortType = currentFilters.sortType
    if (currentFilters.sortField === sortField) {
      sortType = sortType === 'desc' ? 'asc' : 'desc'
    }

    return Object.assign({}, state, {
      filters: {
        ...state.filters,
        sortField,
        sortType
      }
    })
  },
  // SET COLUMNS VIEW
  [types.SET_USERS_COLUMNS_VIEW](state, action) {
    return Object.assign(
      {},
      state,
      {
        cols_order: action.cols_order?.length
          ? action.cols_order
          : colsShowInit
      }
    )
  },
  // SET CHECKS
  [types.SET_USERS_SEARCH_CHECKS](state, payload) {
    return { ...state, checked: payload.conversationsId }
  },
  // TOGGLE IS ALL CHECKS
  [types.TOGGLE_USERS_SEARCH_IS_ALL_CHECKS](state) {
    return { ...state, isAllChecked: !state.isAllChecked }
  },
  // SEARCH USERS
  [types.SEARCH_USERS_REQUEST](state, action) {
    const newState = Object.assign({}, state, {
      isSearchingUsers: true,
      searchUsersSuccess: false,
      searchUsersFailure: false,
      searchUsersError: '',
    })
    return newState
  },
  [types.SEARCH_USERS_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      isSearchingUsers: false,
      searchUsersSuccess: true,
      searchUsersFailure: false,
      searchUsersError: '',
      search_users: action.users,
      search_users_count: action.count,
      lastSearchedUsers: Date.now(),
    })

    return newState
  },
  [types.SEARCH_USERS_FAILURE](state, action) {
    const newState = Object.assign({}, state, {
      isSearchingUsers: false,
      searchUsersSuccess: false,
      searchUsersFailure: true,
      searchUsersError: action.error,
    })
    return newState
  },
  // USERS QUERY
  [types.FETCH_USERS_QUERY_REQUEST](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingQueryUsers: true,
      fetchUsersQuerySuccess: false,
      fetchUsersQueryFailure: false,
      fetchUsersQueryError: '',
    })
    return newState
  },
  [types.FETCH_USERS_QUERY_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingQueryUsers: false,
      fetchUsersQuerySuccess: true,
      fetchUsersQueryFailure: false,
      fetchUsersQueryError: '',
      users_query: action.users,
      total_users_query: action.total_users,
      lastUpdatedUsersQuery: Date.now(),
    })
    return newState
  },
  [types.FETCH_USERS_QUERY_FAILURE](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingQueryUsers: false,
      fetchUsersQuerySuccess: false,
      fetchUsersQueryFailure: true,
      fetchUsersQueryError: action.error,
    })
    return newState
  },
  [types.SEARCH_USERS_SET_CENTERS](state, action) {
    return updateState(state, {
      brands: action.brands || [],
      delegations: action.delegations || []
    })
  },
  [types.CLEAR_SEARCH_RESULTS](state, action) {
    const newState = Object.assign({}, state, {
      search_users: [],
      search_users_count: 0,
      filters: {
        ...state.filters,
        limit: 30
      }
    })
    return newState
  },
  [types.SEARCH_USERS_UPDATE_USER](state, action){
    let searchUsers = state.search_users
    const idxUser = searchUsers.findIndex(el => el._id === action.user._id)
    if(idxUser !== -1) {
      searchUsers[idxUser] = action.user
    }
    const newState = Object.assign({}, state, {
      search_users: searchUsers
    })
    return newState
  }
})
